import jwtDecode from "jwt-decode"
import { userType } from "@/lib/enums"
import { getCookie, removeCookie, setCookie } from "tiny-cookie"

export default class User {
  static getToken() {
    return getCookie("token")
  }

  static setToken(token) {
    setCookie("token", token)
  }

  static removeToken(token) {
    removeCookie("token")
  }

  static getUserType() {
    let token = getCookie("token")
    try {
      return jwtDecode(token).user_type
    } catch (e) {
      return undefined
    }
  }

  static getUserId() {
    let token = getCookie("token")
    try {
      return parseInt(jwtDecode(token).user_id)
    } catch (e) {
      return undefined
    }
  }

  static isLoggedIn() {
    try {
      let jwt = jwtDecode(getCookie("token"))
      if ("user_type" in jwt && "user_type" in jwt) {
        return true
      }
      return false
    } catch (e) {
      return false
    }
  }

  static name() {
    let jwt = jwtDecode(getCookie("token"))
    return jwt.first_name + " " + jwt.last_name
  }

  static isMember() {
    return !!(User.getUserType() & userType.MEMBER)
  }

  static isManager() {
    return !!(User.getUserType() & userType.MANAGER)
  }

  static isPresident() {
    return !!(User.getUserType() & userType.PRESIDENT)
  }

  static isManagerOrPresident() {
    return User.isManager() || User.isPresident()
  }
}
